import { createMakeStyles } from 'tss-react';
import { useTheme } from '@material-ui/core';

const { makeStyles } = createMakeStyles({ useTheme });

export const useStyles = makeStyles()({
  table: {
    '& tbody': {
      maxHeight: '40vh',
      overflowY: 'scroll',
      display: 'block',
    },
  },
});
